import React from 'react';
import './VerificationScreen.css';

const VerificationScreen = ({ onNext, onBack, onDataUpdate, data }) => {
  return (
    <div className="verification-screen">
      <h1>Verification</h1>
      <p>Coming soon...</p>
      <div className="form-actions">
        <button onClick={onBack} className="back-button">
          Back
        </button>
        <button onClick={onNext} className="next-button">
          Next
        </button>
      </div>
    </div>
  );
};

export default VerificationScreen; 